import React from 'react';
import Form from '../../components/Form';

class Register extends React.Component {
    render () {
        return (
            <div className="Register">
                <Form />
            </div>
        );
    }
}

export default Register;

